import {
    GA4EventName,
    GA4FeatureCategory,
    GA4ItemListType,
    trackProductTileServiceInteraction,
} from '@jsmdg/tracking';

const onServicesActionButtonClick = (
    title: string,
    url: string,
    event?: React.MouseEvent<HTMLButtonElement>,
): void => {
    event?.preventDefault();
    trackProductTileServiceInteraction('ProductTile', 'ButtonClick', 'More information', {
        eventName: GA4EventName.ClickButton,
        feature_category: GA4FeatureCategory.ProductList,
        click_element: 'Producttile more information',
        click_text: 'Mehr erfahren',
        list_type: GA4ItemListType.LastSeen,
        product_title: title,
    });
    window.location.href = url;
};

const onCloseServices = (title: string): void => {
    trackProductTileServiceInteraction('ProductTile', 'Close', 'Services', {
        eventName: GA4EventName.ClickTextLink,
        feature_category: GA4FeatureCategory.ProductList,
        click_element: 'Producttile close',
        click_text: 'X',
        list_type: GA4ItemListType.LastSeen,
        product_title: title,
    });
};

const onToggleServices = (showServices: boolean, title: string): void => {
    trackProductTileServiceInteraction(
        'ProductTile',
        showServices ? 'Collapse' : 'Expand',
        'Services',
        {
            eventName: GA4EventName.ClickTextLink,
            feature_category: GA4FeatureCategory.ProductList,
            click_element: showServices ? 'Producttile collapse' : 'Producttile expand',
            click_text: 'Details',
            list_type: GA4ItemListType.LastSeen,
            product_title: title,
        },
    );
};

export { onCloseServices, onServicesActionButtonClick, onToggleServices };
